import VisitaBotoxList from "./pages/VisitaBotoxList.vue"
import VisitaBotoxEdit from "./pages/VisitaBotoxEdit.vue"
import VisitaBotoxView from "./pages/VisitaBotoxView.vue"


export default {
    VisitaBotoxList,
    VisitaBotoxEdit,
    VisitaBotoxView,
  };